import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShieldSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M17.7985 18.5597L19.7505 20.4291M25.7649 18.0594C25.7649 25.8843 15.9996 28.7226 15.9996 28.7226C15.9996 28.7226 6.23558 25.8856 6.23558 18.0594C6.23558 10.2332 5.87961 9.62169 6.66361 8.86944C7.44894 8.11603 14.7196 5.6825 15.9996 5.6825C17.2809 5.6825 24.5503 8.10976 25.3343 8.86944C26.1196 9.62797 25.7649 10.2344 25.7649 18.0594ZM15.1611 12.1125C17.3024 12.1125 19.0385 13.7788 19.0385 15.8337C19.0385 17.8888 17.3024 19.5538 15.1611 19.5538C13.0211 19.5538 11.2852 17.8888 11.2852 15.8337C11.2852 13.7788 13.0211 12.1125 15.1611 12.1125Z",
		stroke: "#596180",
		strokeWidth: 1.8,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgShieldSearch;
